import ajax from "./ajax";

export function getBannersByCategory(category) {
  
  return ajax(`/Banner/GetAllBanners?category=${category}`);
  
}
